import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';

/**
 * Homepage class.
 */
export default class Navigation extends withBreakpointObserver(Base) {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'Video',
    refs: ['items[]', 'background'],
    options: {
      inactiveBreakpoints: {
        type: String,
        default: 'xxs xs s m',
      },
    },
  };

  /**
   * Set current Item background
   * @param {object} element
   */
  setCurrentItem(element) {
    if (!element) {
      if (this.current) {
        this.current.classList.remove('text-white');
        this.$refs.background.style.transform = 'translateX(0px)';
        this.$refs.background.style.width = '0px';
        this.current = null;
      }
      return;
    }

    const xPosition = element.getBoundingClientRect().left - this.$el.getBoundingClientRect().left;

    this.$refs.background.style.transform = `translateX( ${xPosition}px )`;
    this.$refs.background.style.width = `${element.offsetWidth}px`;
    if (this.current !== element && this.current) {
      this.current.classList.remove('text-white');
    }

    this.current = element;
    this.current.classList.add('text-white');
  }
}
